module.exports = __webpack_public_path__ + "media/application/images/2025/title-750-14f40eeda446db25d496b1eb29dc951f.png";